import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { OrganizationSchema, WebsiteSchema } from '@/components/seo';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Global SEO Schemas */}
      <OrganizationSchema />
      <WebsiteSchema />
      
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
}
